import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { Group, GroupsApi } from 'src/app/hickory-api';
import { MatDialog } from '@angular/material/dialog';
import { finalize, Subject, takeUntil } from 'rxjs';
import { GroupsSelectDialogComponent, GroupsSelectDialogData } from '../groups-select-dialog/groups-select-dialog.component';

@Component({
  selector: 'app-groups-form-field',
  templateUrl: './groups-form-field.component.html',
  styleUrl: './groups-form-field.component.scss',
  standalone: false
})
export class GroupsFormFieldComponent implements OnInit, OnDestroy {
  @Input() tenantId: number;
  @Input() groups: number[];
  @Output() groupsChange = new EventEmitter<Group[]>();
  groupsLoading = false;
  selectedGroups: Group[] = [];
  destroy$ = new Subject<void>();

  constructor(
    private readonly dialog: MatDialog,
    private readonly groupsApi: GroupsApi,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.getGroups(this.groups);
  }

  removeGroup(index: number) {
    this.selectedGroups.splice(index, 1);
    this.groupsChange.emit(this.selectedGroups);
  }

  getGroups(groupIds: number[]) {
    if (!groupIds?.length) {
      return;
    }

    this.groupsLoading = true;
    this.groupsApi
      .getGroupsV4(this.tenantId, groupIds, null, 1, 500)
      .pipe(
        finalize(() => (this.groupsLoading = false)),
        takeUntil(this.destroy$),
      )
      .subscribe({
        next: (response) => {
          const groups = response.items;
          if (!groups?.length) {
            return;
          }
          this.mergeSelectedGroups(groups);
        },
      });
  }

  selectGroups() {
    const dialog = this.dialog.open(GroupsSelectDialogComponent, {
      data: {
        existingGroupIds: this.groups,
        tenantId: this.tenantId,
        hideClassification: true,
      } as GroupsSelectDialogData,
      maxWidth: '1000px',
      minWidth: '400px',
      width: '75%',
      height: '80%',
      ariaLabel: 'Group selection tree',
    });

    dialog.afterClosed().subscribe((groups: Group[]) => {
      if (!groups?.length) {
        return;
      }

      this.mergeSelectedGroups(groups);
      this.groupsChange.emit(this.selectedGroups);
    });
  }

  mergeSelectedGroups(groups: Group[]) {
    const groupMap = new Map(this.selectedGroups.map((group) => [group.id, group]));
    groups.forEach((group) => groupMap.set(group.id, group));
    this.selectedGroups = Array.from(groupMap.values());
  }
}
